import Terminos from './Terminos';
export default Terminos;